<div *ngIf="message" role="alert" class="m-alert m-alert--outline alert alert-{{ message.type }} alert-dismissible">
    <button type="button" data-dismiss="alert" aria-label="Close" class="close"></button>
    <span>{{ message.text }}</span>
</div>
